import React from "react";
import { Box, Typography } from "@mui/material";
import new_help_icon from '../../../../asset/image/new_help.svg';

interface ModeInfoCardProps {
  title: string;
  description: string[];
  width?: string | number;
}

const ModeInfoCard: React.FC<ModeInfoCardProps> = ({
  title,
  description,
  width = "50%",
}) => {
  return (
    <Box
      sx={{
        border: "1px solid #D1D5DB",
        borderRadius: "8px",
        p: 2,
        backgroundColor: "#FFFFFF",
        width,
        paddingBottom: '40px'
      }}
    >
      <Typography
        variant="subtitle1"
        fontWeight={600}
        sx={{ display: "flex", alignItems: "center", gap: 1.5, fontFamily: 'Inter', fontSize: '16px', fontWeight: '600' }}
      >
        {title}
        <img src={new_help_icon} alt="" />
      </Typography>

      {description.map((line, i) => (
        <Typography
          key={i}
          variant="body2"
          sx={{
            mt: i === 0 ? 1 : 0.5,
            color: "#111827",
            fontWeight: '400',
            fontFamily: 'Inter',
            fontSize: '12px',
            pr: 2
          }}
        >
          {line}
        </Typography>
      ))}
    </Box>
  );
};

export default ModeInfoCard;